import isLocalStorageSupported from './isLocalStorageSupported';
import * as trace from 'owa-trace';

/**
 * Gets value corresponding to key.
 */
const getItem = (key: string) => {
    try {
        if (isLocalStorageSupported()) {
            return JSON.parse(window.localStorage.getItem(key));
        }
    } catch (error) {
        trace.errorThatWillCauseAlert(`[getItem]: ${error}`);
    }
    return null;
};

export default getItem;
